import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["href"];
var _hoisted_2 = { class: "ecosystem-swiper__card" };
var _hoisted_3 = ["src"];
var _hoisted_4 = { class: "ecosystem-swiper__card-title" };
import { Swiper, SwiperSlide } from 'swiper/vue';
import { normalizeUrl } from '@/utils/process-link';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EcosystemSwiper',
    props: {
        ecosystemList: {
            type: Object,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_unref(Swiper), {
                class: "ecosystem-swiper",
                "slides-per-view": 'auto',
                "space-between": 9,
                freeMode: true
            }, {
                default: _withCtx(function () { return [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ecosystemList, function (card) {
                        return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                            class: "ecosystem-swiper__slide",
                            key: card.id
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("a", {
                                    href: _unref(normalizeUrl)(card.link),
                                    target: "_blank"
                                }, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("img", {
                                            src: card.image,
                                            alt: "",
                                            class: "ecosystem-swiper__card-image"
                                        }, null, 8, _hoisted_3),
                                        _createElementVNode("p", _hoisted_4, _toDisplayString(card.name), 1)
                                    ])
                                ], 8, _hoisted_1)
                            ]; }),
                            _: 2
                        }, 1024));
                    }), 128))
                ]; }),
                _: 1
            }));
        };
    }
});
